module.exports = __webpack_public_path__ + "img/mg-reward-logo.f77877d3.png";